import { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Sizes } from '@common/types';
import { Box, Modal, Notification, NotificationAlignment, NotificationVariants } from '@base-app';

import { COMMON_TRANSLATION } from '@constants/index';
import { SelectDateRangeModalFormValues, SelectDateRangeModalProps } from './SelectDateRangeModal.types';
import DateRangeForm from './DateRangeForm/DateRangeForm';

const SelectDateRangeModal: FC<SelectDateRangeModalProps> = ({
  dateRangeErrorDescription,
  dateRangeErrorTitle,
  endDate,
  isOpen,
  maxDate,
  minDate,
  onClose,
  onSubmit,
  startDate,
  toggle,
}) => {
  const { t } = useTranslation(COMMON_TRANSLATION);
  const [rangeError, setRangeError] = useState<boolean>(false);

  const handleClose = (): void => {
    toggle();
    onClose?.();
  };

  const handleSubmitForm = ({ fromDate, toDate }: SelectDateRangeModalFormValues): void => {
    onSubmit({
      fromDate: new Date(fromDate),
      toDate: new Date(toDate),
    });
  };

  return (
    <Modal
      data-testid="select-date-range-modal"
      onClose={handleClose}
      show={isOpen}
      title={t('select_date_range_modal.title')}
      size={Sizes.SMALL}
    >
      {rangeError && !!dateRangeErrorTitle && (
        <Box>
          <Notification
            css={{ marginBottom: '$4' }}
            variant={NotificationVariants.ERROR}
            title={dateRangeErrorTitle}
            description={dateRangeErrorDescription}
            textAlign={NotificationAlignment.LEFT}
          />
        </Box>
      )}
      <DateRangeForm
        onSubmit={handleSubmitForm}
        startDate={startDate}
        endDate={endDate}
        maxDate={maxDate}
        minDate={minDate}
        setRangeError={setRangeError}
      />
    </Modal>
  );
};

export default SelectDateRangeModal;
